export const name = 'pdfDownloadController';
export default function pdfDownloadController(fileDownloaderFactory,pdfListService, errorDialogOpen, $mdDialog, $window){
    //noinspection BadExpressionStatementJS
    'ngInject';
    /* jshint validthis: true */

    let vm = this;
    vm.pdfsIdToDownload = [];
    vm.isAllCompleted = true;
    vm.downloadInProgress = false;
    vm.close = close;
    vm.dontShowThisMessageAgain = dontShowThisMessageAgain;
    vm.showPopupEnableMessage  = false;
    vm.dontShowPopupEnableMessageAgain = false;
    vm.isSafari = null;
    vm.getErrorIcon = getErrorIcon;
    vm.getInformationIcon = getInformationIcon;
    vm.isErrorCase = false;

    let iconsRequire = require.context('@printos/imposer-ui/src/components/templates/images/icons', false, /\.svg/);
    let errorIcon = iconsRequire("./error.svg");
    let informationIcon = iconsRequire("./information.svg");

    initialize();

    function initialize(){
        for (let pdfIndex in vm.selectedPdfs) {
            if(vm.selectedPdfs[pdfIndex] === undefined || vm.selectedPdfs[pdfIndex] === null || (vm.selectedPdfs[pdfIndex].status !== 'completed' && vm.selectedPdfs[pdfIndex].status !=='warning')){
                vm.isAllCompleted = false;
            }
        }

        vm.isSafari = navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0;
        vm.pdfsIdToDownload = vm.selectedPdfs.map(curr => curr.pdfId);
        if(vm.isAllCompleted && vm.pdfsIdToDownload.length <= 20 && !vm.isSafari){
            download();
        }else if(vm.isAllCompleted && vm.pdfsIdToDownload.length === 1 && vm.isSafari){ // Safari support single download only
            download();
        }else{
            // then it is case:
            vm.isErrorCase = true;
        }
    }


    function download(){
        if(vm.isAllCompleted && vm.pdfsIdToDownload.length <= 20){
            vm.downloadInProgress = true;
            if(vm.pdfsIdToDownload.length > 0){
                pdfListService.getPdfDownloadUrls(vm.pdfsIdToDownload).then(
                    function(downloadPdfUrlCollection){
                        if(downloadPdfUrlCollection !== undefined && downloadPdfUrlCollection !== null &&
                            downloadPdfUrlCollection.pdfUrlList !== undefined && downloadPdfUrlCollection.pdfUrlList !== null && downloadPdfUrlCollection.pdfUrlList.length > 0){

                            for(let iPdfUrl = 0; iPdfUrl < downloadPdfUrlCollection.pdfUrlList.length; iPdfUrl++){
                                downloadPdfUrlCollection.pdfUrlList[iPdfUrl].url = downloadPdfUrlCollection.pdfUrlList[iPdfUrl].pdfUrl;
                                downloadPdfUrlCollection.pdfUrlList[iPdfUrl].fileName = downloadPdfUrlCollection.pdfUrlList[iPdfUrl].pdfName;
                                if ($window.Intercom) {
                                  $window.Intercom('trackEvent', 'Composer - PDF Downloaded');

                                }
                            }
                            fileDownloaderFactory.downloadUrls(downloadPdfUrlCollection.pdfUrlList, vm.isSafari);
                        }
                        $window.Intercom('update');
                        automaticClose();
                    },function(status){
                        errorDialogOpen.openErrorDialog(status);
                    }
                );
            }
        }
    }

    function close(){
        $mdDialog.hide();
    }

    function automaticClose(){
        let dontShowAgainPopupEnabledMessage = localStorage.getItem("composer.dontShowAgainPopupEnabledMessage");

        if((dontShowAgainPopupEnabledMessage === undefined || dontShowAgainPopupEnabledMessage === null || dontShowAgainPopupEnabledMessage === "false") && !vm.isSafari){
            vm.showPopupEnableMessage = true;
            vm.downloadInProgress = false;
            vm.dontShowPopupEnableMessageAgain = false;
        }else{
            $mdDialog.hide();
        }
    }

    function dontShowThisMessageAgain(){
        if(vm.dontShowPopupEnableMessageAgain){
            localStorage.setItem("composer.dontShowAgainPopupEnabledMessage", true);
        }else{
            localStorage.setItem("composer.dontShowAgainPopupEnabledMessage", false);
        }
    }

    function getErrorIcon(){
        return errorIcon;
    }

    function getInformationIcon(){
        return informationIcon;
    }
}
